<style>
    .wrapper {
        position: fixed;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        background-color: rgba(255,255,255,.5);
        z-index: 9999;
        display: grid;
        align-items: center;
        text-align: center;
        height: 100vh;
        width: 100vw;
    }

    .v-dot {
        display: inline-block;
    }
</style>

<template>
    <div class="wrapper" v-if="loading">
        <dot-loader :loading="loading" :color="color" :size="size"></dot-loader>
    </div>
</template>

<script>
import RiseLoader from 'vue-spinner/src/RiseLoader'
import DotLoader from 'vue-spinner/src/DotLoader'
export default {
  name: 'Loader',
  components: {DotLoader, RiseLoader},
  data () {
    return {
      size: '120px',
      color: '#5dc596'
    }
  },
  computed: {
    loading () {
      return this.$store.state.loading.loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Loader.vue